module.exports = __webpack_public_path__ + "static/media/card-edit.e8d408ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-edit.png
// module id = 464
// module chunks = 33